module.exports = __webpack_public_path__ + "img/la-memorial-coliseum_1.8b1fbf7f.jpg";